{
  "de": {
    "task": {
      "actions": {
        "create": "Aufgabe",
        "create_and_send": "Erstellen und senden",
        "delete": "Aufgabe löschen",
        "open_in_project": "Aufgabe im Projekt öffnen",
        "remove_from_unit": "Aufgabe von dieser Einheit entfernen",
        "save_as_draft": "Als Entwurf speichern",
        "update": "Aufgabe bearbeiten"
      },
      "attributes": {
        "assignments_count": "Zuweisungen",
        "category": "Art des Abschlusses",
        "created_at": "Erstellt",
        "description": "Beschreibung",
        "phase": "Phase",
        "title": "Titel",
        "units": "Einheiten"
      },
      "categories": {
        "confirmation": "Bestätigung",
        "upload": "Dokument hochladen"
      },
      "categories_info": {
        "confirmation": "Die verantwortliche Person hakt die Aufgabe ab, sobald sie erledigt ist.",
        "upload": "Die verantwortliche Person muss ein Dokument hochladen, um die Aufgabe zu erledigen."
      },
      "confirm": {
        "delete_body": "Die Aufgabe verschwindet, und jede Zuweisung darunter ebenfalls: {assignments} über {units}.",
        "delete_header": "„{title}“ löschen?",
        "delete_silent": "Niemand wird benachrichtigt, und bereits versendete Benachrichtigungen werden nicht zurückgenommen.",
        "remove_from_unit_body": "Jede verantwortliche Person für „{title}“ auf {unit} verliert sie. Die Aufgabe selbst und ihre anderen Einheiten bleiben unverändert.",
        "remove_from_unit_customers": "Die Kunden von {unit} sehen sie nicht mehr in ihrem Portal.",
        "remove_from_unit_header": "Diese Aufgabe von {unit} entfernen?"
      },
      "deep_link": {
        "show_all": "Alle Aufgaben anzeigen",
        "single": "Sie sehen eine Aufgabe aus einer Benachrichtigung."
      },
      "empty": {
        "filtered_description": "Passe deine Filter an oder lösche sie, um alle Aufgaben zu sehen.",
        "filtered_title": "Keine Aufgaben passen zu deinen Filtern",
        "none_title": "Keine Aufgaben"
      },
      "filters": {
        "phase_none": "Keine Phase"
      },
      "labels": {
        "assignments_count": "{count} Zuweisung | {count} Zuweisungen",
        "created_by": "Erstellt von {name} · {date}",
        "created_on": "Erstellt am {date}",
        "no_tasks": "Noch keine Aufgaben für dieses Projekt.",
        "required": "Dieses Feld ist erforderlich",
        "set_all_assignees": "Für die verantwortliche Person setzen | Für alle {count} Verantwortlichen setzen",
        "still_to_do": "noch {count} offen",
        "units_count": "{count} Einheit | {count} Einheiten",
        "units_required": "Wählen Sie mindestens eine Einheit aus"
      },
      "toasts": {
        "create": "Aufgabe erstellt",
        "delete": "Aufgabe gelöscht",
        "remove_from_unit": "Aufgabe von dieser Einheit entfernt",
        "update": "Aufgabe aktualisiert"
      }
    }
  }
}
